/**
 * Created by zzy on 2019/8/6.
 */
import Bar from './Bar.vue'
export default Bar



// WEBPACK FOOTER //
// ./src/components/echarts/bar/index.js